<template>
  <ListResult
    v-if="parent"
    :type="'lab'"
    :course="lab"
    :gradient="gradient"
    :tileImg="`${getBackground(parent)}`"
    :difficulty="''"
    :link="getLabLink(lab, parent)"
    :parent="parent"
    :learningAreaColor="getLearningAreaColor(parent)"
    :learningArea="getLearningArea(parent)"
    :displayDuration="false"
    :duration="null"
    :displayLabType="false"
    :displayInstructor="false"
    :displayParentCourse="true"
    :courseName="parent ? parent.name : ''"
    :running="running"
    :displayRunningPill="true"
    :showAddedDate="true"
    @el-rend="handleRememberPosition"
  />
</template>

<script>
import ListResult from '@/components/search/ListResult.vue'
import { getLearningAreaColor, getLearningArea } from '@/helpers'
import CONSTANTS from '@/constants'

export default {
  name: 'LabListResult',
  components: {
    ListResult,
  },
  data: () => {
    return {
      getLearningAreaColor,
      getLearningArea,
    }
  },
  props: {
    lab: {
      type: Object,
      required: false,
    },
    backgroundImg: {
      type: String,
      required: false,
    },
    gradient: {
      type: String,
      required: false,
    },
    parent: {
      type: Object,
      required: false,
      default: () => {},
    },
    running: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  methods: {
    getLabTypeLabel(labType) {
      if (!labType) {
        return null
      }
      const types = {
        azure: 'Azure',
        github: 'GitHub',
        els: 'eLearningSecurity',
        pta: 'Pentester Academy',
      }
      return types[labType]
    },
    showLastActivity(lab) {
      return course?.last_activity_date && course?.last_activity_date !== 'None'
    },
    getTimeInDaysAgo(lab) {
      const time = course?.last_activity_date ?? ''
      return time && time !== 'None'
        ? `${formatDistance(new Date(), new Date(time))} ago`
        : ''
    },
    getBackground(parent) {
      if (parent) {
        return this.$getPlaylistBackground(parent.objectID)
      }
      return null
    },
    getLabLink(lab, parent) {
      if (parent) {
        return this.$buildContentLink('lab', lab, parent)
      }
      return {}
    },
    handleRememberPosition(elId) {
      this.$emit('elmt-rend', elId)
    },
  },
}
</script>
